import React from "react";
import Header from "@/components/Header";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import Footer from "@/components/Footer";
import Tos from "@/components/landing/Tos";

export default function PrivacyPolicyPage() {
  return (
    <div className="">
      <Head>
        {generateNextSeo({
          title: "Terms of Service",
          description:
            "Review the Terms of Service for Uptime Monitor, outlining the rules and guidelines for using our website monitoring services. Ensure you understand your rights and obligations when using our platform.",
          canonical: "https://uptime-monitor.io/tos",
          openGraph: {
            title: "Terms of Service - Uptime Monitor",
            description:
              "Read our terms of service for using Uptime Monitor, the website monitoring platform.",
            url: "https://uptime-monitor.io/tos",
          },
        })}
      </Head>
      <div>
        <Header />

        <Tos />

        <Footer />
      </div>
    </div>
  );
}
